import { pdfjs } from 'react-pdf';

let isPdfJsWorkerConfigured = false;

export function configurePdfJsWorker() {
  if (isPdfJsWorkerConfigured) {
    return;
  }

  pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.mjs`;
  isPdfJsWorkerConfigured = true;
}
